import { GridCellProps } from '@progress/kendo-react-grid';
import { FC } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { getBackgroundColor } from 'src/utils';

const TotalAmountCell: FC<GridCellProps> = (props: GridCellProps) => {
  const { value, displayValue } = useGridCellDisplayValue(props);

  return (
    <GridCellBase
      {...props}
      style={getBackgroundColor(value)}
      title={displayValue}
      className="!text-right"
    >
      <span>{displayValue}</span>
    </GridCellBase>
  );
};

export default TotalAmountCell;
